import React, { useEffect, useState } from 'react'
import { ICarouselNavItems } from 'components/swiper/swiperNav'
import { IdeaApplicationFormProps } from './contracts'
import { FormAnswer } from 'components/Evaluation/Form/Answer/FormAnswer'
import { trans } from 'sharedKernel/i18n'
import { NoContent } from 'components/NoContent'
import { FormIdeaDesktop } from './Desktop'
import { FormIdeaMobile } from './Mobile'
import { getDeviceType } from 'sharedKernel/behaviors'
import { SectionTitle, SectionDivider, SectionContent } from './styles'

export const IdeaApplicationForm = ({
  setIsNavigationBlocked,
  ideaApplicationData,
  stepName
}: IdeaApplicationFormProps): JSX.Element => {
  const labels = {
    emptyForm: trans('Não há informações a serem exibidas')
  }

  function buidSteps(
    sections: any[]
  ): { formSteps: any[]; carouselNavItems: ICarouselNavItems[] } {
    const carouselNavItems: ICarouselNavItems[] = []
    const formSteps: any[] = []

    sections.map((section, sectionIndex) => {
      const appFormSection = ideaApplicationData.challenge.applicationForm?.sections?.find(item => item.id === section.sectionId)

      if (appFormSection?.isHidden === false) {
        carouselNavItems.push({
          name: section.name ?? '',
          itemHash: section.id
        })
        formSteps.push({
          name: section.id,
          sectionName: section.name ?? '',
          component: (
            <div key={`${sectionIndex}section`}>
              <SectionTitle>{section.name ?? ''}</SectionTitle>
              <SectionDivider />
              <SectionContent>
                {section.answers?.map((answer, answerIndex) => {
                  const sectionField = appFormSection.fields.find(field => field.id === answer.questionId)
                  if (sectionField?.isHidden === false) {
                    return <FormAnswer key={`${answerIndex}answer`} answer={answer} />
                  }
                  return <></>
                })}
              </SectionContent>
            </div>
          )
        })
      }

      return section
    })

    return {
      carouselNavItems,
      formSteps
    }
  }

  const formIdeaSectionsBody = (): JSX.Element => {
    if (formSteps.length === 0 || formSteps.length === undefined) {
      return (
        <NoContent text={labels.emptyForm}></NoContent>
      )
    }

    return (
      <>
        {formSteps.map((step, stepIndex) => {
          return (
            <section id={step.name} key={stepIndex} className={stepIndex === 0 ? 'first-section' : ''}>
              {step.component}
            </section>
          )
        })}
      </>
    )
  }

  const resolverId = ideaApplicationData.company.id
  const solution = !ideaApplicationData.challenge.config.hideIdeaTitle ? ideaApplicationData.title : 'Empresa oculta'
  const sections = ideaApplicationData.sections
  const evaluation = ideaApplicationData.evaluation
  const challengeId = ideaApplicationData.challenge.id
  const solutionId = ideaApplicationData.id

  const { carouselNavItems, formSteps } = buidSteps(sections)
  const [deviceType, setDeviceType] = useState(getDeviceType(window.innerWidth))

  const handleResize = (): void => {
    setDeviceType(getDeviceType(window.innerWidth))
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  if (deviceType === 'mobile') {
    return (
      <FormIdeaMobile
        solutionTitle={solution}
        evaluation={evaluation}
        formIdeaSectionsBody={formIdeaSectionsBody()}
        resolverId={resolverId}
        challengeId={challengeId}
        solutionId={solutionId}
        setIsNavigationBlocked={setIsNavigationBlocked}
        stepName={stepName}
      />
    )
  }
  return (
    <FormIdeaDesktop
      solutionTitle={solution}
      evaluation={evaluation}
      formIdeaSectionsBody={formIdeaSectionsBody()}
      resolverId={resolverId}
      challengeId={challengeId}
      solutionId={solutionId}
      setIsNavigationBlocked={setIsNavigationBlocked}
      stepName={stepName}
    />
  )
}
